import {
  RailwayOrderStatus,
  SeatClass
} from '@link/china-railway/services/types';

export default {
  common: {
    colon: ': ',
    cancel: '取消',
    confirm: '確認'
  },
  date: {
    month: {
      month1: '一月',
      month2: '二月',
      month3: '三月',
      month4: '四月',
      month5: '五月',
      month6: '六月',
      month7: '七月',
      month8: '八月',
      month9: '九月',
      month10: '十月',
      month11: '十一月',
      month12: '十二月'
    },
    weeks: {
      sun: '日',
      mon: '一',
      tue: '二',
      wed: '三',
      thu: '四',
      fri: '五',
      sat: '六'
    }
  },
  seatClass: {
    [SeatClass.Business]: '商務座',
    [SeatClass.Premium]: '特等座',
    [SeatClass.First]: '一等座',
    [SeatClass.Second]: '二等座'
  },
  confirmBooking: {
    title: '溫馨提示',
    description: '確認預訂後，不可變更資訊。請仔細確認以下資訊：',
    preOrderDescription:
      '確認預約後，請提前15天進入【訂單詳情】頁面查看搶票狀態，不會通過郵件或短信發送搶票結果。',
    departTime: '出發時間',
    trainNumber: '列車班次',
    seatNumber: '車廂/座位號',
    autoAssign: '自動分配',
    passengerName: '預約姓名',
    ticketCount: '預約數量',
    confirmBook: '確認預訂',
    date: '{{month}}月{{day}}日',
    orderSuccess: '預訂成功',
    orderFailed: '預訂失敗, 請稍後再試'
  },
  views: {
    booking: {
      bookingId: '訂單 {{id}}'
    },
    railway: {
      details: '訂單詳情',
      booking: '預訂高鐵',
      ticketCount: '票數',
      selectDate: '選擇乘車日期',
      moreTime: '更多時間',
      bookTicket: '預訂車次',
      status: {
        [RailwayOrderStatus.StatusUnspecified]: '未知狀態',
        [RailwayOrderStatus.Reserved]: '訂票中，請稍後',
        [RailwayOrderStatus.Booked]: '訂票中，請稍後',
        [RailwayOrderStatus.Cancelling]: '取消中',
        [RailwayOrderStatus.Cancelled]: '已取消',
        [RailwayOrderStatus.Closed]: '餘票不足，請重新訂票',
        [RailwayOrderStatus.Issuing]: '訂票中，請稍後',
        [RailwayOrderStatus.Issued]: '訂票成功，已出票',
        [RailwayOrderStatus.Used]: '已使用'
      },
      usageDate: '使用日期'
    },
    trainList: {
      book: '預訂',
      preBook: '預約',
      noTrains: '該時間段暫無車次',
      hour: '小時',
      minute: '分',
      durationFormat: '{{hours}}小時{{minutes}}分',
      ticketsLeft: '餘票{{count}}張',
      noTickets: '票已售罄',
      notOnSale: '暫未開售'
    },
    orderDetail: {
      title: '訂單詳情',
      faq: '常見問題',
      dateTimeFormat: '{{year}}年{{month}}月{{day}}日 {{time}}',
      travelInfo: '出行資訊',
      departureTime: '出發時間',
      trainNumber: '列車班次',
      seatNumber: '車廂/座位號',
      passengerName: '預約姓名',
      ticketCount: '預約數量',
      highSpeedTicket: '高鐵動車票',
      orderId: '訂單ID',
      orderTime: '訂單完成時間',
      rebookTicket: '重新訂票',
      preOrderStatus: '已預約，{{days}}天後開售',
      saleDate: '開售日期',
      saleDateFormat: '{{year}}年{{month}}月{{day}}日',
      cancelOrder: '取消訂單',
      cancelOrderSuccess: '取消訂單成功',
      cancelOrderFailed: '取消訂單失敗，請稍後再試',
      cancelOrderDialog: {
        title: '確定取消訂單',
        content: '取消訂單後可重新購票',
        confirm: '確認取消',
        cancel: '暫不取消'
      }
    }
  }
};
